module.exports = __webpack_public_path__ + "static/media/SVG_top_menu_burger.6661c7cc.svg";